import { render, staticRenderFns } from "./tumorProgress.vue?vue&type=template&id=3c12f61b&scoped=true"
import script from "./tumorProgress.vue?vue&type=script&lang=js"
export * from "./tumorProgress.vue?vue&type=script&lang=js"
import style0 from "./tumorProgress.vue?vue&type=style&index=0&id=3c12f61b&prod&scoped=true&lang=css"
import style1 from "./tumorProgress.vue?vue&type=style&index=1&id=3c12f61b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c12f61b",
  null
  
)

export default component.exports